import { render, staticRenderFns } from "./backTenderingMessage.vue?vue&type=template&id=56e06214&scoped=true"
import script from "./backTenderingMessage.vue?vue&type=script&lang=js"
export * from "./backTenderingMessage.vue?vue&type=script&lang=js"
import style0 from "./backTenderingMessage.vue?vue&type=style&index=0&id=56e06214&prod&lang=less&scoped=true"
import style1 from "./backTenderingMessage.vue?vue&type=style&index=1&id=56e06214&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e06214",
  null
  
)

export default component.exports